"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require("redux");

var _configReducer = require("./config/configReducer");

var _configReducer2 = _interopRequireDefault(_configReducer);

var _developmentReducer = require("./development/developmentReducer");

var _developmentReducer2 = _interopRequireDefault(_developmentReducer);

var _dockerReducer = require("./docker/dockerReducer");

var _dockerReducer2 = _interopRequireDefault(_dockerReducer);

var _fileReducer = require("./file/fileReducer");

var _fileReducer2 = _interopRequireDefault(_fileReducer);

var _helmReducer = require("./helm/helmReducer");

var _helmReducer2 = _interopRequireDefault(_helmReducer);

var _kubernetesReducer = require("./kubernetes/kubernetesReducer");

var _kubernetesReducer2 = _interopRequireDefault(_kubernetesReducer);

var _packagesReducer = require("./packages/packagesReducer");

var _packagesReducer2 = _interopRequireDefault(_packagesReducer);

var _s3Reducer = require("./s3/s3Reducer");

var _s3Reducer2 = _interopRequireDefault(_s3Reducer);

var _serverReducer = require("./server/serverReducer");

var _serverReducer2 = _interopRequireDefault(_serverReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  config: _configReducer2.default,
  development: _developmentReducer2.default,
  docker: _dockerReducer2.default,
  file: _fileReducer2.default,
  helm: _helmReducer2.default,
  kubernetes: _kubernetesReducer2.default,
  packages: _packagesReducer2.default,
  s3: _s3Reducer2.default,
  server: _serverReducer2.default
});
//# sourceMappingURL=reducer.js.map


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/dist/reducer.js
// module id = 252
// module chunks = 0